export const getNotificationStatus = (state) => {
  return state.notification.active;
};

export const getNotificationType = (state) => {
  return state.notification.type;
};

export const getNotificationData = (state) => {
  return state.notification.data;
};
